import PropTypes from 'prop-types';
import { NavLink as RouterLink } from 'react-router-dom';
import { Box, List, ListItemText, ListSubheader, Divider } from '@mui/material';
import { removeUserSession } from '../../utils/common';
import { StyledNavItem, StyledNavItemIcon } from './styles';

NavSection.propTypes = {
  data: PropTypes.array,
};

export default function NavSection({ data = [], ...other }) {
  const navconficMain = [];
  const navconficManage = [];
  const navconficLogout = [];

  for (const c of data) {
    if (c.title === 'Dashboard' || c.title === 'Dataset Map' || c.title === 'Alerts') {
      navconficMain.push(c);
    }

    if (
      c.title === 'Calendar' ||
      c.title === 'Information' ||
      c.title === 'Reports' ||
      c.title === 'Actions' ||
      c.title === 'Users' ||
      c.title === 'About' ||
      c.title === 'Activity Log'
    ) {
      navconficManage.push(c);
    }

    if (c.title === 'Logout') {
      navconficLogout.push(c);
    }
  }

  return (
    <Box {...other}>
      <List disablePadding sx={{ p: 1 }}>
        <ListSubheader sx={{ marginLeft: 0, color: '#12A2CE', fontWeight: 'bold', lineHeight: 'normal', fontSize: '1.1rem', backgroundColor: '#F9FAFB', py: 1.5 }}>
          Main
        </ListSubheader>
        {navconficMain?.map((item) => (
          <NavItem key={item.title} item={item} />
        ))}
        {navconficManage?.length > 0 && (
          <ListSubheader sx={{ marginLeft: 0, color: '#12A2CE', fontWeight: 'bold', lineHeight: 'normal', fontSize: '1.1rem', backgroundColor: '#F9FAFB', py: 1.5 }}>
            Manage
          </ListSubheader>
        )}
        {navconficManage?.map((item) => (
          <NavItem key={item.title} item={item} />
        ))}
        <Divider sx={{ marginY: 1, marginX: 2.5 }} />

        {navconficLogout?.map((item) => (
          <NavItem key={item.title} item={item} />
        ))}
      </List>
    </Box>
  );
}

NavItem.propTypes = {
  item: PropTypes.object,
};

function NavItem({ item }) {
  const { title, path, icon, info } = item;

  const handleLogout = (event) => {
    if (title === 'Logout') {
      event.preventDefault(); // Prevent navigation to /login
      removeUserSession(); // Call logout immediately
      return;
    }
  };

  return (
    <StyledNavItem
      component={RouterLink}
      to={path}
      onClick={handleLogout}
      sx={{
        '&.active': {
          color: 'white',
          bgcolor: '#12A2CE',
          fontWeight: 'fontWeightBold',
        },
        color: '#12A2CE',
      }}
    >
      <StyledNavItemIcon>{icon}</StyledNavItemIcon>
      <ListItemText disableTypography primary={title} />
      {info}
    </StyledNavItem>
  );
}
